import React from 'react';

export const PrintIcon: React.FC<{ className?: string }> = ({ className }) => {
	return (
		<svg
			width="27"
			height="26"
			viewBox="0 0 27 26"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={className}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M21.0833 0V7.58333H23.25C25.0316 7.58333 26.5 9.05176 26.5 10.8333V21.6667H21.0833V26H5.91667V21.6667H0.5V10.8333C0.5 9.05176 1.96842 7.58333 3.75 7.58333H5.91667V0H21.0833ZM18.9193 17.334H8.08594V23.834H18.9193V17.334ZM23.2474 9.75H3.7474C3.13379 9.75 2.66406 10.2197 2.66406 10.8333V19.5H5.91406V15.1667H21.0807V19.5H24.3307V10.8333C24.3307 10.2197 23.861 9.75 23.2474 9.75ZM4.83333 10.834C5.43001 10.834 5.91667 11.3206 5.91667 11.9173C5.91667 12.514 5.43001 13.0006 4.83333 13.0006C4.23665 13.0006 3.75 12.514 3.75 11.9173C3.75 11.3206 4.23665 10.834 4.83333 10.834ZM18.9193 2.16602H8.08594V7.58269H18.9193V2.16602Z"
			/>
		</svg>
	);
};
